import type { ClientSharePointWebLinkEmbed, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

export const findById: FindById<'clientSharePointWebLinkEmbeds'> = createFindById('clientSharePointWebLinkEmbeds');
export const findByIdThrows: FindByIdThrows<'clientSharePointWebLinkEmbeds'> = createFindByIdThrows(
  'clientSharePointWebLinkEmbeds'
);

type GetFulfilledClientSharePointWebLinkEmbeds = (state: YammerState) => Record<string, ClientSharePointWebLinkEmbed>;
export const getFulfilledClientSharePointWebLinkEmbeds: GetFulfilledClientSharePointWebLinkEmbeds = (state) =>
  state.clientSharePointWebLinkEmbeds.fulfilled.byId;
